<ng-container *transloco="let t"><div class="shadow-sm {{nonmblex ? 'nonmblex' : ''}}">
  <a [routerLink]="aliasUrl">
    <h6><app-culture-string [content]="Name"></app-culture-string></h6>
    <img src="{{imageUrl}}" />
    <div *ngIf="nonmblex" class="mblexalert">{{ t('TopicCard.NotTested') }}</div>
  </a>
</div>
</ng-container>